import * as React from 'react'

import { TFProductCategory } from '~graphql/generated/graphql'
import { createContext } from '~logic/lib/react'

import { useReplacePrice } from '../hooks/useReplacePrice'

type TProductListData = Nullable<RoA<TFProductCategory>>
type TTotalCountContext = Nullable<number>

type TCombinationMealsData = ReturnType<typeof useReplacePrice>

type TLoadReturn = {
  productCategories: TProductListData
  productCategoryCount: TTotalCountContext
  replacePrices: TCombinationMealsData
}

const [
  ProductListProvider, //
  useProductListDataCtx,
] = createContext<TProductListData>(`ProductListData`)

const [
  ProductListCountProvider, //
  useProductListCountCtx,
] = createContext<TTotalCountContext>(`ProductListTotalCount`)

const [
  ProductListCombinationMealProvider, //
  useProductListCombinationMealCtx,
] = createContext<TCombinationMealsData>(`ProductListCombinationMeal`)

type TProps = RequiredChildren & {
  useLoadProductList: () => TLoadReturn
}

/**
 * Provides:
 *  - raw unfiltered product list categories
 *  - the total count of product list categories.
 *  - combination meals list
 */
export const ProductListDataProvider: React.FC<TProps> = ({ useLoadProductList, children }) => {
  const { productCategories, productCategoryCount, replacePrices } = useLoadProductList()

  return (
    <ProductListProvider value={productCategories}>
      <ProductListCombinationMealProvider value={replacePrices}>
        <ProductListCountProvider value={productCategoryCount}>{children}</ProductListCountProvider>
      </ProductListCombinationMealProvider>
    </ProductListProvider>
  )
}

export { useProductListCountCtx, useProductListDataCtx, useProductListCombinationMealCtx }
